var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1285 1220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M673.5 559.915V644.915",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M737.5 569.915V650.915",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587.808 938C566.675 940.631 517.202 950.336 506.365 970.07C503.114 975.992 499.343 990.399 510.266 1000.66C521.191 1010.92 541.153 1008.23 549.768 1005.59L600 985.365",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M875.8 789.076C836.368 790.345 662.206 874.661 580.054 916.661C573.059 962.941 602.58 996.171 618.215 1007C700.102 983.227 868.167 935.046 885.34 932.51C902.513 929.975 919.525 917.718 925.885 911.907C970.406 859.922 937.546 815.756 915.55 800.171C899.892 789.076 886.375 788.735 875.8 789.076Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M506.432 777.282C534.371 779.146 656.251 826.382 714 851.139L581.93 917.134C522.824 934.467 486.515 928.757 475.426 925.021C411.419 894.184 436.497 818.106 461.928 789.924C478.318 775.974 496.421 776.615 506.432 777.282Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M817.386 947C834.848 955.391 844.29 966.386 849.077 975.402C859.336 998.881 840.915 1012.99 819.884 1006.36C808.262 1002.69 805.522 1000.23 799.367 995.129C796.243 992.538 781.655 978.983 765 962.973",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M482.073 546.323L495.48 789.964C495.772 795.266 500.155 799.415 505.465 799.415H879.5C885.023 799.415 889.5 794.938 889.5 789.415V540.551C889.5 534.975 884.94 530.477 879.365 530.552L491.923 535.775C486.238 535.851 481.76 540.646 482.073 546.323Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M880 802.915H503C497.753 802.915 493.5 807.168 493.5 812.415C493.5 817.662 497.753 821.915 503 821.915H880C885.247 821.915 889.5 817.662 889.5 812.415C889.5 807.168 885.247 802.915 880 802.915Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M738.5 424.915C773.333 424.415 850 450.915 880.5 534.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M662 424.415C582.5 439.915 544.5 473.915 514.5 539.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M928 503.5L947.5 471",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M947.5 512.5L974 490.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M951.5 527.5C956.667 529.5 968.4 531.4 974 523",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M440 497.415L410 466.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M470.5 492.415L452.5 445.915",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M432.5 514.915L410 506.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M900.5 590.5C919 619.5 940 654 900.5 718.915",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M739 427.415C743.5 414.415 739.4 405.667 735.4 404C711.4 426 675 417.833 661.5 404.5C656.7 408.9 659.5 421.915 661.5 425.915C687.5 454.715 724.5 438.581 739 427.415Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M632.5 507.415L640.53 495.09C648.356 483.077 663.588 478.281 676.885 483.643L696.022 491.359C707.961 496.174 721.641 492.834 730.019 483.06L752 457.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M476 608.915C468.5 626.582 459.6 669.415 484 699.415",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M807.943 223.021C796.943 262.521 791.443 266.021 775.443 283.521C775.443 266.226 772.472 237.196 772.472 225.108C720.083 225.108 675.869 203.722 660.311 193.029C660.869 229.292 626.872 253.003 626.872 253.003C626.872 253.003 631.748 267.648 634.535 300.425C636.764 326.646 630.355 321.579 626.872 315.767C616.84 283.409 600.398 292.056 593.431 300.425C507.944 161.521 639.411 134.681 664.49 137.238C683.439 121.059 709.866 108.38 728.443 106.521C795.443 99.8136 825.779 158.973 807.943 223.021Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M628.043 340.49C637.043 395.436 697.451 434.945 741.043 390.436C784.635 345.926 775.912 264.454 771.254 226.436",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M592.443 297.021C586.943 310.521 592.103 340.435 628.043 340.435",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M608.294 304.436C607.499 307.324 608.135 314.169 617.043 318.436",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M770.043 333.436C781.773 328.545 790.043 310.436 786.861 281.436",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M704.043 366.436C715.543 369.436 714.816 361.18 723.543 353.936",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M738.373 304.085C742.515 304.085 745.873 300.727 745.873 296.585C745.873 292.443 742.515 289.085 738.373 289.085C734.231 289.085 730.873 292.443 730.873 296.585C730.873 300.727 734.231 304.085 738.373 304.085Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M672.373 305.085C676.515 305.085 679.873 301.727 679.873 297.585C679.873 293.443 676.515 290.085 672.373 290.085C668.231 290.085 664.873 293.443 664.873 297.585C664.873 301.727 668.231 305.085 672.373 305.085Z",
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M656.043 280.436C657.621 275.789 664.431 267.192 679.043 269.98",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M726.043 271.436C729.528 268.417 739.007 264.191 749.043 271.436",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M701.85 292.436C700.685 302.31 699.893 322.333 706.043 323.436",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M686.5 1220C823.19 1220 934 1206.57 934 1190C934 1173.43 823.19 1160 686.5 1160C549.81 1160 439 1173.43 439 1190C439 1206.57 549.81 1220 686.5 1220Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopMan);
export default __webpack_public_path__ + "static/media/laptop-man.0a71bdcd09872f7cd881065df2824079.svg";
export { ForwardRef as ReactComponent };